import { cornType } from '@eigtech/shared-corn';
export const claimsV2ServiceCorn = (eventName) => cornType('claims', eventName);
export const ClaimsV2ServiceCornSchema = claimsV2ServiceCorn();
export const ClaimV2CornSchema = claimsV2ServiceCorn('claim');
export const isClaimV2Corn = (entityId) => ClaimV2CornSchema.safeParse(entityId).success;
